import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.number.to-fixed.js";
import { defineComponent, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { BookingStatus, PSSType } from "@/types/db/product-slot-state";
import { formatDateTime } from "@/utils/helpers/dates";
import { AccountingState, PaymentMethods, TransactionTypes } from "@/types/db/accounting";
import { sumArray } from "@/utils/helpers/common";
import { getPSSValue } from "@/utils/helpers/product-slot-state";
import { getPssGroupDiscount } from "@/utils/vue-helpers/new-accountings";
export default defineComponent({
  name: "CustomerBasket",
  props: {
    // objetcContaining all needed data for UI
    basketData: {
      required: true,
      type: Object
    }
  },
  setup: function setup(props) {
    console.log("hi from setup of CustomerBasket"); /////// initiating reactive properties as null, in mounted hook we destructure the props ans assign these properties a value

    var showRemoveBtn = ref(null);
    var isInThePast = ref(null);
    var showCancelTicketsModal = ref(null);
    var iconContent = ref(null);
    var iconAlt = ref(null);
    var iconStyle = ref(null);
    var bookings = ref(null);
    var bookingList = ref(null);
    var currency = ref(null);
    var pssList = ref(null);
    var isCompletedBooking = ref(null);
    var bookingStep = ref(null);
    var BookingStep = ref(null);
    var isInPaymentStep = ref(null);
    var isInOrderStep = ref(null);
    var confirmedAmountsInfo = ref(null);
    var confirmedAmountsTotal = ref(null);
    var payingCurrency = ref(null);
    var getCustomerFullName = ref(null);
    var hasAppliedDiscount = ref(null);
    var isDiscountOnAllOrder = ref(null);
    var discountTotal1 = ref(null);
    var discountTotal = ref(null);
    var whatIsLeftToPay = ref(null);
    var total1 = ref(null);
    var total = ref(null);
    var isLongTitle = ref(null);
    var onClickCustomers = ref(null);
    var getPSSNewPriceValue = ref(null);
    var groupedPSSList = ref(null);
    var deleteUnconfirmedTickets = ref(null);
    var deleteTickets = ref(null);
    var isPSSConsideredInDiscount = ref(null);
    var removePayment = ref(null);
    var deleteConfirmedAmount = ref(null);
    var isAccountingCompleted = ref(null);
    var doesSupportSplitPayment = ref(null);
    var balance1 = ref(null);
    var isEditOrder = ref(null);
    var alreadyPaidAmount = ref(null);
    var refundedAmount = ref(null);
    var refreshDiscount = ref(null);
    var closeCalculator = ref(null);
    var confirmedPSSToDelete = ref(null);
    var DeleteIcon = ref(null);
    var openMessageBox = ref(null);
    var closeModal = ref(null);
    var orderValueExcludingCancelledTickets = ref(null);
    var splitPayments = ref(null);
    var amountPaid = ref(null);
    var translatePaymentMethods = ref(null);
    var totalTax = ref(null);
    var bookingSynchingDateTime = ref(null);
    var groupCurrency = ref(null);
    var currenciesUsedInPayment = ref(null);
    var getPackageTotalValue = ref(null);
    var bookingHasSeatingPlan = ref(null);
    var isRemoveButtonLoading = ref(null); //////////////////////////////////////////////

    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var selectedBooking = ref(null);
    var groupCurrencies = ref(null); //POSConfigModule.groupCurrencies;

    function showTicketInfo(pss) {
      // Show ticket product info (startDateTime, priceName ...etc) only if the product is not a merch product
      var b = pss.pssType === PSSType[PSSType.Ticket];
      return b;
    }
    /**
     * Whether or not these pss belongs to a generic Discount accounting
     */


    function hasGenericDiscountAccountings(pssGroup) {
      // a list of the uuids of the pssGroup
      var rowPssListUuids = pssGroup.pssIds;
      var discountAccountings = selectedBooking.value ? selectedBooking.value.accountings.filter(function (acc) {
        return acc.state === AccountingState.Completed && (acc.paymentMethod === PaymentMethods.METHOD_DISCOUNT || acc.paymentMethod === PaymentMethods.METHODS_POS_DISCOUNT);
      }) : [];

      if (discountAccountings && discountAccountings.length) {
        var accEntries = discountAccountings.map(function (acc) {
          return acc.accountingEntriesList;
        }).flat();
        var filteredPssDiscounts = accEntries.filter(function (item) {
          return rowPssListUuids.some(function (element) {
            return element === item.productSlotStateUuid;
          });
        });

        if (filteredPssDiscounts && filteredPssDiscounts.length) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    }
    /**
     *
     * Whether or not a given pss is considerd in the promocodeDiscount or the discount
     * we identify it using discount accountings
     */


    function isPSSConsideredInDiscount1(pssGroup) {
      // const pssValuesTracking = BookingModule.bookingLifeTimePssValues;
      var discountAccEntries = [];
      var discountAccountings = selectedBooking.value ? selectedBooking.value.accountings.filter(function (acc) {
        return acc.transactionType === TransactionTypes.TRANSACTION_TYPE_DISCOUNT && !acc.refund && (acc.state === AccountingState.Completed || acc.state === AccountingState.Pending && !acc.id);
      }) : [];

      if (discountAccountings && discountAccountings.length) {
        discountAccEntries = discountAccountings === null || discountAccountings === void 0 ? void 0 : discountAccountings.map(function (acc) {
          return acc.accountingEntriesList;
        }).flat();
      }

      var index = discountAccEntries.findIndex(function (ae) {
        return ae.productSlotStateUuid === pssGroup.uuid;
      });

      if (index === -1) {
        // there is no discount for this pss
        return false;
      } else {
        return true;
      }
    }
    /**
     *
     * Whether or not a given pssGroup is a free ticket or not
     */


    function isFreeTicket(pssGroup) {
      var value = getPSSValue(pssGroup);
      var _discountValue = pssGroup._discountValue;
      return value === 0 && _discountValue === 0;
    }
    /**
     * Value returned is fully based on accountings
     * e.g: Discount 50% / CHF 6.00
     * The discount can be coming from a promocodeDiscount or a normal discount or both
     * Or from DISCOUNT accounting
     */


    function getTicketDiscount1(pssGroup) {
      // all pss that are concerned in discount/promocodeDiscount
      var discountAccEntries = [];
      var discountAccountings = selectedBooking.value ? selectedBooking.value.accountings.filter(function (acc) {
        return !acc.refund && acc.transactionType === TransactionTypes.TRANSACTION_TYPE_DISCOUNT && (acc.state === AccountingState.Completed || acc.state === AccountingState.Pending);
      }) : [];

      if (!discountAccountings || !discountAccountings.length) {
        // there is no discount accountings
        return "";
      }

      discountAccEntries = discountAccountings.map(function (acc) {
        return acc.accountingEntriesList;
      }).flat(); // a list of the uuids of the pssGroup

      var rowPssListUuids = pssGroup.pssIds; // list of pss from the pssGroup and that are considered in the discount/promocodeDiscount

      var filteredPssDiscounts = discountAccEntries.filter(function (ae) {
        return rowPssListUuids.some(function (element) {
          return element === ae.productSlotStateUuid && ae.value > 0;
        });
      });

      if (filteredPssDiscounts && filteredPssDiscounts.length) {
        var pssGroupPricesSum = pssGroup.quantity * getPSSValue(pssGroup);
        var pssGroupDiscountsSum = sumArray(filteredPssDiscounts.map(function (it) {
          return it.value;
        }));
        var newPriceSum = pssGroupPricesSum - pssGroupDiscountsSum;
        return t("discount.discount") + " " + ((pssGroupPricesSum - newPriceSum) / pssGroupPricesSum * 100).toFixed(0) + "%" + " / " + ((pssGroupPricesSum - newPriceSum) / 100).toFixed(2) + " " + String(selectedBooking.value.currency);
      }

      return "";
    }

    function getStatusTranslation(pss) {
      if (pss.bookingStatus === BookingStatus.Confirmed && pss.pssType === PSSType[PSSType.Retail]) {
        return t("common.confirmed-sets");
      }

      if (pss.bookingStatus === BookingStatus.Canceled && pss.pssType === PSSType[PSSType.Retail]) {
        return t("common.cancelled-sets");
      }

      if (pss.bookingStatus === BookingStatus.Confirmed && pss.pssType === PSSType[PSSType.Ticket]) {
        return t("common.confirmed-tickets");
      }

      if (pss.bookingStatus === BookingStatus.Canceled && pss.pssType === PSSType[PSSType.Ticket]) {
        return t("common.cancelled-tickets");
      }
    }

    return {
      groupCurrencies: groupCurrencies,
      getStatusTranslation: getStatusTranslation,
      showRemoveBtn: showRemoveBtn,
      isInThePast: isInThePast,
      showCancelTicketsModal: showCancelTicketsModal,
      iconContent: iconContent,
      iconAlt: iconAlt,
      iconStyle: iconStyle,
      t: t,
      bookings: bookings,
      bookingList: bookingList,
      selectedBooking: selectedBooking,
      currency: currency,
      pssList: pssList,
      isCompletedBooking: isCompletedBooking,
      bookingStep: bookingStep,
      BookingStep: BookingStep,
      isInPaymentStep: isInPaymentStep,
      isInOrderStep: isInOrderStep,
      confirmedAmountsInfo: confirmedAmountsInfo,
      confirmedAmountsTotal: confirmedAmountsTotal,
      payingCurrency: payingCurrency,
      getCustomerFullName: getCustomerFullName,
      hasAppliedDiscount: hasAppliedDiscount,
      isDiscountOnAllOrder: isDiscountOnAllOrder,
      discountTotal1: discountTotal1,
      discountTotal: discountTotal,
      whatIsLeftToPay: whatIsLeftToPay,
      total1: total1,
      total: total,
      isLongTitle: isLongTitle,
      isPSSConsideredInDiscount1: isPSSConsideredInDiscount1,
      isPSSConsideredInDiscount: isPSSConsideredInDiscount,
      isFreeTicket: isFreeTicket,
      PSSType: PSSType,
      onClickCustomers: onClickCustomers,
      getPSSNewPriceValue: getPSSNewPriceValue,
      getTicketDiscount1: getTicketDiscount1,
      groupedPSSList: groupedPSSList,
      deleteUnconfirmedTickets: deleteUnconfirmedTickets,
      AccountingState: AccountingState,
      deleteTickets: deleteTickets,
      showTicketInfo: showTicketInfo,
      formatDateTime: formatDateTime,
      removePayment: removePayment,
      deleteConfirmedAmount: deleteConfirmedAmount,
      isAccountingCompleted: isAccountingCompleted,
      doesSupportSplitPayment: doesSupportSplitPayment,
      balance1: balance1,
      isEditOrder: isEditOrder,
      alreadyPaidAmount: alreadyPaidAmount,
      refundedAmount: refundedAmount,
      refreshDiscount: refreshDiscount,
      closeCalculator: closeCalculator,
      BookingStatus: BookingStatus,
      confirmedPSSToDelete: confirmedPSSToDelete,
      DeleteIcon: DeleteIcon,
      openMessageBox: openMessageBox,
      closeModal: closeModal,
      orderValueExcludingCancelledTickets: orderValueExcludingCancelledTickets,
      splitPayments: splitPayments,
      amountPaid: amountPaid,
      translatePaymentMethods: translatePaymentMethods,
      totalTax: totalTax,
      PaymentMethods: PaymentMethods,
      bookingSynchingDateTime: bookingSynchingDateTime,
      hasGenericDiscountAccountings: hasGenericDiscountAccountings,
      groupCurrency: groupCurrency,
      currenciesUsedInPayment: currenciesUsedInPayment,
      getPSSValue: getPSSValue,
      getPackageTotalValue: getPackageTotalValue,
      bookingHasSeatingPlan: bookingHasSeatingPlan,
      isRemoveButtonLoading: isRemoveButtonLoading,
      getPssGroupDiscount: getPssGroupDiscount
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log("hi from mounted of customerBasket");

              _this.updateData();

              watch(_this.$props, function () {
                console.log("props has been changed");

                _this.updateData();
              });
              console.log("done mounted");

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  updated: function updated() {
    console.log("hi from updated of customerBasket");
  },
  methods: {
    updateData: function updateData() {
      console.log("hi from updateData");
      this.selectedBooking = this.$props.basketData.selectedBooking;
      this.groupCurrencies = this.$props.basketData.groupCurrencies;
      this.showRemoveBtn = this.$props.basketData.showRemoveBtn;
      this.isInThePast = this.$props.basketData.isInThePast;
      this.showCancelTicketsModal = this.$props.basketData.showCancelTicketsModal;
      this.iconContent = this.$props.basketData.iconContent;
      this.iconAlt = this.$props.basketData.iconAlt;
      this.iconStyle = this.$props.basketData.iconStyle;
      this.bookings = this.$props.basketData.bookings;
      this.bookingList = this.$props.basketData.bookingList;
      this.currency = this.$props.basketData.currency;
      this.pssList = this.$props.basketData.pssList;
      this.isCompletedBooking = this.$props.basketData.isCompletedBooking;
      this.bookingStep = this.$props.basketData.bookingStep;
      this.BookingStep = this.$props.basketData.BookingStep;
      this.BookingStep = this.$props.basketData.BookingStep;
      this.isInPaymentStep = this.$props.basketData.isInPaymentStep;
      this.isInOrderStep = this.$props.basketData.isInOrderStep;
      this.confirmedAmountsInfo = this.$props.basketData.confirmedAmountsInfo;
      this.confirmedAmountsTotal = this.$props.basketData.confirmedAmountsTotal;
      this.payingCurrency = this.$props.basketData.payingCurrency;
      this.getCustomerFullName = this.$props.basketData.getCustomerFullName;
      this.hasAppliedDiscount = this.$props.basketData.hasAppliedDiscount;
      this.isDiscountOnAllOrder = this.$props.basketData.isDiscountOnAllOrder;
      this.discountTotal1 = this.$props.basketData.discountTotal1;
      this.discountTotal = this.$props.basketData.discountTotal;
      this.whatIsLeftToPay = this.$props.basketData.whatIsLeftToPay;
      this.total1 = this.$props.basketData.total1;
      this.total = this.$props.basketData.total;
      this.isLongTitle = this.$props.basketData.isLongTitle;
      this.onClickCustomers = this.$props.basketData.onClickCustomers;
      this.getPSSNewPriceValue = this.$props.basketData.getPSSNewPriceValue;
      this.groupedPSSList = this.$props.basketData.groupedPSSList;
      this.deleteUnconfirmedTickets = this.$props.basketData.deleteUnconfirmedTickets;
      this.deleteTickets = this.$props.basketData.deleteTickets;
      this.isPSSConsideredInDiscount = this.$props.basketData.isPSSConsideredInDiscount;
      this.removePayment = this.$props.basketData.removePayment;
      this.deleteConfirmedAmount = this.$props.basketData.deleteConfirmedAmount;
      this.isAccountingCompleted = this.$props.basketData.isAccountingCompleted;
      this.doesSupportSplitPayment = this.$props.basketData.doesSupportSplitPayment;
      this.balance1 = this.$props.basketData.balance1;
      this.isEditOrder = this.$props.basketData.isEditOrder;
      this.alreadyPaidAmount = this.$props.basketData.alreadyPaidAmount;
      this.refundedAmount = this.$props.basketData.refundedAmount;
      this.refreshDiscount = this.$props.basketData.refreshDiscount;
      this.closeCalculator = this.$props.basketData.closeCalculator;
      this.confirmedPSSToDelete = this.$props.basketData.confirmedPSSToDelete;
      this.DeleteIcon = this.$props.basketData.DeleteIcon;
      this.openMessageBox = this.$props.basketData.openMessageBox;
      this.closeModal = this.$props.basketData.closeModal;
      this.orderValueExcludingCancelledTickets = this.$props.basketData.orderValueExcludingCancelledTickets;
      this.splitPayments = this.$props.basketData.splitPayments;
      this.amountPaid = this.$props.basketData.amountPaid;
      this.translatePaymentMethods = this.$props.basketData.translatePaymentMethods;
      this.totalTax = this.$props.basketData.totalTax;
      this.bookingSynchingDateTime = this.$props.basketData.bookingSynchingDateTime;
      this.groupCurrency = this.$props.basketData.groupCurrency;
      this.currenciesUsedInPayment = this.$props.basketData.currenciesUsedInPayment;
      this.getPackageTotalValue = this.$props.basketData.getPackageTotalValue;
      this.isRemoveButtonLoading = this.$props.basketData.isRemoveButtonLoading;
    }
  }
});